module.exports = __webpack_public_path__ + "img/es.8b157e32.png";